import { useEffect, useState } from "react";
import { Table, Button, Modal, Input, Select, Badge } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import Navbar from "../components/Navbar";
import appwriteClient from '../appwrite.config';
import { Databases, ID, Query , Account} from "appwrite";
import { toast } from "react-toastify";

const { Option } = Select;

const UserManagement = () => {

  const databases = new Databases(appwriteClient);
  const appwriteAccount = new Account(appwriteClient);


  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [newUser, setNewUser] = useState({ displayName: "", email: "", phoneNumber: "", password: "", role: "", status: "Active", zoneRegister: [] });
  const [zones,setZones] = useState([]);

  const handleAddUser = async () => {
    appwriteAccount.create(ID.unique(),newUser.email,newUser.password,newUser.displayName).then((resp)=>{

      databases.createDocument(
        'AppwriteCloudFEApp',
        'UserRegister',
        ID.unique(),
        newUser
      ).then((res)=>{
        toast.success('User created successfully!')
        setUsers([...users, res]);
        setNewUser({ displayName: "", email: "", phoneNumber: "", password: "", role: "", status: "Active", zoneRegister: [] });
        setIsModalOpen(false);
      }).catch((err)=>{
        console.log(err);
        toast.error('Error creating new user!')
      })
    })
   
  };

  const handleEditUser = () => {
    console.log(editingUser)
    databases.updateDocument(
      'AppwriteCloudFEApp',
      'UserRegister',
      editingUser.$id,
      {
        phoneNumber:editingUser.phoneNumber,
        role:editingUser.role,
        status:editingUser.status,
        zoneRegister:editingUser.zoneRegister

      }
    ).then((res)=>{
      toast.success('User updated successfully!')
      setUsers(users.map((user) => (user.$id === editingUser.$id ? res : user)));
      setEditingUser(null);
      setIsModalOpen(false);
    }).catch((err)=>{
      console.log(err);
     toast.error('Error updating user!')
    })

  };

  const handleDeleteUser = (id) => {
    databases.deleteDocument(
      'AppwriteCloudFEApp',
      'UserRegister',
      id
    ).then((res)=>{
      toast.success('User deleted successfully!')
      setUsers(users.filter((user) => user.id !== id));
    }).catch((err)=>{
      console.log(err)
      toast.error('Error deleting user!')
    })
  };
  
  
      useEffect(()=>{
          databases.listDocuments(
              'AppwriteCloudFEApp',
              'UserRegister',
              [
                  Query.limit(500)
              ]
          ).then((response)=>{
              setUsers(response.documents)
          }).catch((error)=>{
              console.log(error);
              toast.error('Error getting users!')
          })
      },[])


      
      useEffect(()=>{
        databases.listDocuments(
            'AppwriteCloudFEApp',
            'ZoneRegister',
            [
                Query.limit(500)
            ]
        ).then((res)=>{
            const zonesArr = [];
            res.documents.map((zone)=>{
              zonesArr.push({label:zone.zoneName,value:zone.$id})
            })
            setZones(zonesArr);
        }).catch((error)=>{
            console.log(error);
            toast.error('Error getting users!')
        })
    },[])


  const columns = [
    {
      title: "Display Name",
      dataIndex: "displayName",
      key: "displayName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Badge status={status === "Active" ? "success" : "error"} text={status} />
      ),
    },
    {
      title: "Zone Register",
      dataIndex: "zoneRegister",
      key: "zoneRegister",
      render: (zones) => {
        if (!Array.isArray(zones)) return "-"; 
        console.log(zones);
        return zones.map(zone => zone.zoneName).join(", ");
      },
    },    
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Button
            icon={<EditOutlined />}
            onClick={() => {
              const recordData = {};
              recordData.$id=record.$id;
              recordData.displayName=record.displayName;
              recordData.email=record.email;
              recordData.password=record.password;
              recordData.phoneNumber=record.phoneNumber;
              recordData.role=record.role;
              recordData.status=record.status;
              recordData.zoneRegister=record.zoneRegister.map((zone)=>{
                return zone.$id
              })
              setEditingUser(recordData);
              setIsModalOpen(true);
            }}
            style={{ marginRight: 8 }}
          />
          <Button icon={<DeleteOutlined />} danger onClick={() => handleDeleteUser(record.id)} />
        </>
      ),
    },
  ];

  return (
    <>
     <Navbar page={"User Register"}/>
    <div className="p-10">
      <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
        Add User
      </Button>
      <Table dataSource={users} columns={columns} rowKey="id" style={{ marginTop: 20 }} />
      <Modal
        title={editingUser ? "Edit User" : "Add User"}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setEditingUser(null);
        }}
        onOk={editingUser ? handleEditUser : handleAddUser}
      >
        <Input
          placeholder="Display Name"
          disabled={editingUser}
          value={editingUser ? editingUser.displayName : newUser.displayName}
          onChange={(e) =>
            editingUser
              ? setEditingUser({ ...editingUser, displayName: e.target.value })
              : setNewUser({ ...newUser, displayName: e.target.value })
          }
          style={{ marginBottom: 10 }}
        />
        <Input
          placeholder="Email"
          disabled={editingUser}
          value={editingUser ? editingUser.email : newUser.email}
          onChange={(e) =>
            editingUser
              ? setEditingUser({ ...editingUser, email: e.target.value })
              : setNewUser({ ...newUser, email: e.target.value })
          }
          style={{ marginBottom: 10 }}
        />
        <Input
          placeholder="Phone Number"
          value={editingUser ? editingUser.phoneNumber : newUser.phoneNumber}
          onChange={(e) =>
            editingUser
              ? setEditingUser({ ...editingUser, phoneNumber: e.target.value })
              : setNewUser({ ...newUser, phoneNumber: e.target.value })
          }
          style={{ marginBottom: 10,marginTop:10 }}
        />
        <Input
          placeholder="Password"
          type="password"
          maxLength={10}
          minLength={10}
          disabled={editingUser}
          value={editingUser ? editingUser.password : newUser.password}
          onChange={(e) =>
            editingUser
              ? setEditingUser({ ...editingUser, password: e.target.value })
              : setNewUser({ ...newUser, password: e.target.value })
          }
          style={{ marginBottom: 10 }}
        />
        <Select
          value={editingUser ? editingUser.role : newUser.role}
          onChange={(value) =>
            editingUser
              ? setEditingUser({ ...editingUser, role: value })
              : setNewUser({ ...newUser, role: value })
          }
          style={{ width: "100%", marginBottom: 10 }}
        >
          <Option value="Driver">Driver</Option>
          <Option value="FieldExcecutive">Field Excecutive</Option>
          <Option value="Manager">Manager</Option>
          <Option value="Admin">Admin</Option>
          
        </Select>
        <Select
          value={editingUser ? editingUser.status : newUser.status}
          onChange={(value) =>
            editingUser
              ? setEditingUser({ ...editingUser, status: value })
              : setNewUser({ ...newUser, status: value })
          }
          style={{ width: "100%", marginBottom: 10 }}
        >
          <Option value="Active">Active</Option>
          <Option value="Inactive">Inactive</Option>
        </Select>
        <Select
          mode="multiple"
          placeholder="Select Zones"
          filterOption={(inputValue, option) => {
            console.log(option)
           return option.children.toLowerCase().includes(inputValue.toLowerCase())
          }}
          value={editingUser ? editingUser.zoneRegister: newUser.zoneRegister}
          onChange={(value) =>{
            console.log(value)
            editingUser
              ? setEditingUser({ ...editingUser, zoneRegister: value })
              : setNewUser({ ...newUser, zoneRegister: value })
          }
          }
          style={{ width: "100%", marginBottom: 10 }}
        >
          {zones.map((zone)=>{
            return (
              <Option value={zone.value}>{zone.label}</Option>
            )
          })}
        </Select>
      </Modal>
    </div>
    </>
  );
};

export default UserManagement;


